module.exports = __webpack_public_path__ + "static/media/lit.0c40a951.png";